import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import 'react-day-picker/dist/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Container from './Container';

var stateManager = require('./utils/state/stateManager.js');

ReactDOM.render(
  <Provider store={stateManager.getStore()}>
      <Container />
  </Provider>, 
  
document.getElementById('root'));
